import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import styled from "styled-components";
import Footer from "../../components/Footer";
import Header from "../../components/Navbar";
import Comments from "../../components/Posts/Comments";
import ProfileInfo from "../../components/Profile/ProfileInfo";
import { UsePostsContext } from "../../store/contexts/posts.context";
import Container from "../../UI/Container";
import ContentWrapper from "../../UI/ContentWrapper";

function SinglePostPage() {
  const [post, setpost] = useState(null);
  const [body, setbody] = useState("");
  const [author, setauthor] = useState();
  const { getPostBody, getPost, setViews, getAuthor } = UsePostsContext();
  const params = useParams();
  useEffect(() => {
    (async function setPost() {
      const p = await getPost(params.id);
      setpost(p.data);
      try {
        const res = await getPostBody(params.id);
        setbody(res.data);
      } catch (e) {
        console.log(e);
      }
      await getAuthor(p.data.post_author_id).then((res) => {
        setauthor(res.data);
      });
    })();
    setViews(+params.id);
  }, []);

  return (
    post && (
      <Wrapper>
        <Header />
        <div className="devider"></div>
        <Container>
          <h2 className="main-title common">{post.post_title}</h2>
          <p className="author-info" style={{ marginBottom: "40px" }}>
            By{" "}
            <b>
              <NavLink to={`/profile/${author?.id}`}>
                {author?.first_name + " " + author?.second_name}
              </NavLink>
            </b>{" "}
            Published in{" "}
            <b>{new Date(post.post_date).toDateString().slice(3, 100)}</b> -{" "}
            {post.post_views_count} views
          </p>
        </Container>
        <img
          className="banner"
          src={
            "https://flexiblog-science.netlify.app/static/020595d15cf34bfdda8b5954efc8ff86/fc596/image.webp"
          }
          alt=""
        />
        <Container>
          <div className="devider"></div>
          <main>
            <div>
              <ContentWrapper>{body}</ContentWrapper>
              <br />
              <p className="flex start" style={{ gap: "10px" }}>
                {post.post_tags.map((i) => (
                  <NavLink to={`/posts?search=${i}`} className="tag">
                    {i}
                  </NavLink>
                ))}
              </p>
              <div className="devider"></div>
              <Comments id={post.id} />
            </div>
            <ProfileInfo column userData={author} post_id={params.id} />
          </main>
        </Container>
        <div className="devider"></div>
        <Footer />
      </Wrapper>
    )
  );
}

export default SinglePostPage;
const Wrapper = styled.div`
  .banner {
    width: calc(100% - 64px);
    margin: 0 auto;
    display: block;
    border-radius: 18px;
    aspect-ratio: 16/6;
    object-fit: cover;
    object-position: center;
    max-width: 1440px;
    @media (max-width: 991px) {
      width: calc(100% - 32px);
      aspect-ratio: 16/9;
    }
  }
  .author-info {
    margin-top: 12px;
    @media (max-width: 767px) {
      font-size: 12px;
    }
  }
  .main-title {
    font-size: 48px;
    @media (max-width: 991px) {
      font-size: 32px;
    }
    @media (max-width: 767px) {
      font-size: 24px;
    }
  }
  main {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    @media (max-width: 991px) {
      flex-direction: column;
      gap: 24px;
    }
    & > div:first-of-type {
      padding: 0 20px 0 0;
      @media (max-width: 991px) {
        padding: 0;
      }
    }
    & > div {
      width: 100%;
    }
    & > div:last-of-type {
      flex: 0 0 360px;
      width: 100%;
      position: sticky;
      top: 20px;
      & > div > div {
        width: 100%;
        flex: 0 0 100%;
        max-width: 100%;
      }
    }
  }
`;
